module.exports = {
    carbon_dioxide_min: "0",
    carbon_dioxide_max: "5000",
    carbon_dioxide_unit: "ppm",
    ammonia_min: "0",
    ammonia_max: "50",
    ammonia_unit: "ppm",
    hydrogen_sulfide_min: "0",
    hydrogen_sulfide_max: "100",
    hydrogen_sulfide_unit: "ppm",
    temperature_min: "-50",
    temperature_max: "60",
    temperature_unit: "°C",
    humidity_min: "0",
    humidity_max: "100",
    humidity_unit: "%",
    graph_refresh_term: 10, // 단위 minute
    // 장비 Part No. 규칙
    // EMS01-GW-000000 (총 15자리) 
    // EMS Environment Measurement System (3자리)
    // 01  모델번호 (2자리) - 01 : 냄새측정기, 02 : 실내공기질 측정기, 03 : 대기환경 측정기
    // GW  센서종류 (2자리) - GW : Gateway, NS : Node Sensor
    // 000000  제품순번 (6자리)
    sensor_no_site_name: "EMS",
    sensor_no_model_number: "01",
    sensor_no_main_type: "GW", // Gateway
    sensor_no_node_type: "NS", // Node Sensor
    sensor_no_product_number: 6, // Sensor Number 제품순번 (000001 ~ 999999), 6자리
    sensor_no_total_length: 15, // 장비 Part No. 규칙 최대 자릿수
    sensor_no_node_max_count: 10, // Node Sensor 최대 등록 갯수
    sensor_guarantee_period: 5, // 무상 AS 만료일 : 5년
    sensor_check_limit: 1,
    sensor_lifetime_nh3: 30,
    sensor_lifetime_h2s: 30,
    sensor_lifetime_th: 30,
    list_max_count: 10,
    map_center_latitude: 36.6504119,
    map_center_longitude: 127.8845475,
    map_level: 13,
    force_login: 'N'
}
